import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

export class WishlistComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    // 找到按钮元素
    this.button = this.querySelector('[data-wishlist-button]');
    if (!this.button) return;

    // 获取 productId
    this.productId = this.dataset.productId;
    if (!this.productId) return;

    // 初始化状态
    this.updateButtonState();

    // 点击事件
    this.button.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.button) {
      this.button.removeEventListener('click', this.handleClick);
    }
  }

  handleClick = (event) => {
    event.preventDefault();

    const wishlist = this.getWishlist();
    if (wishlist.includes(this.productId)) {
      this.removeFromWishlist(this.productId);
      this.dispatchWishlistEvent('removed');
    } else {
      this.addToWishlist(this.productId);
      this.dispatchWishlistEvent('added');
    }

    this.updateButtonState();
  };

  getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('wishlist') || '[]');
    } catch {
      return [];
    }
  }

  addToWishlist(productId) {
    const wishlist = this.getWishlist();
    if (!wishlist.includes(productId)) {
      wishlist.push(productId);
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
    }
  }

  removeFromWishlist(productId) {
    const wishlist = this.getWishlist().filter((id) => id !== productId);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

  updateButtonState() {
    const wishlist = this.getWishlist();
    const isAdded = wishlist.includes(this.productId);
    this.button.classList.toggle('is-active', isAdded);
    this.button.setAttribute('aria-pressed', isAdded);
  }

  dispatchWishlistEvent(action) {
    const event = new CustomEvent(ThemeEvents.wishlistUpdate || 'wishlist:update', {
      detail: { productId: this.productId, action },
      bubbles: true,
    });
    document.dispatchEvent(event);
  }
}

if (!customElements.get('wishlist-component')) {
  customElements.define('wishlist-component', WishlistComponent);
}
